import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {MeasurementPrecisionTypes} from "@model";
import {RemoveLeadingZerosPipe} from "./remove-leading-zeros.pipe";
import {StringTimeToPrecisionPipe} from "./string-time-to-precision.pipe";

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'resultTime'
})
export class ResultsTimePipe implements PipeTransform {

  constructor(private removeLeadingZerosPipe: RemoveLeadingZerosPipe, private stringTimeToPrecision: StringTimeToPrecisionPipe) {
  }
  transform(time?: string, measurementPrecisionType?: MeasurementPrecisionTypes | undefined): string {
    measurementPrecisionType = measurementPrecisionType ?? MeasurementPrecisionTypes.SECONDS;
    if (!time) {
      return '-';
    }
    const isNegative = time.startsWith('-');
    const absTime = isNegative ? time.slice(1) : time;
    const transformed = this.removeLeadingZerosPipe.transform(this.stringTimeToPrecision.transform(absTime.replace(".000", ""), measurementPrecisionType));
    return isNegative ? '-' + transformed : transformed;
  }
}
